import { useEffect } from 'react';
import useCustomHook from '@/hooks/useCustomHook';
import { useGamificationContext } from '@/shared/Gamification/GamificationContext/GamificationContext';

export default function useDragAndMatchActivity({ taskProgressAPI }) {
  const { state, actions } = useCustomHook({
    defaultState: {},
    actions: {
      onAnswer: ({ gameConf, answers }) => {
        const progress = Math.ceil(
          (answers.length * 100) / gameConf.txts.length
        );
        const correct = Math.ceil(
          (answers.filter((answer) => answer.correct).length * 100) /
            gameConf.txts.length
        );
        taskProgressAPI.PROGRESS({ progress, correct, answers });
      },
    },
  });

  useEffect(() => {}, []);

  return { state, actions };
}
